import React from 'react'

export default function Error({ title }) {
    return (
        <p className='text-red-500 text-sm p-1'>{title}</p>
    )
}
